<template>
    <div>
        <div class="d-flex mb-5">
            <div 
                class="brand-img-without-hover" 
                id="containerLogo" 
                v-bind:style='{backgroundImage: `url("${this.logo}")` }'>
            </div>
            <dropdown-localization v-if="this.$store.state.localization"/>
        </div>        
    </div>
</template>
<script>
    import DropdownLocalization from './../templates/DropdownLocalization'

    var head = document.getElementsByTagName('head')[0];

    export default {
        name : 'TheHeader',  
        components : {
            'dropdown-localization' : DropdownLocalization,
            
        },  
        computed: {            
            logo: function () { return this.$store.state.urlLogo; },
            urlLogo : function () {
                return {
                     '--logo': this.logo
                }
            }
        },
        watch: {
            "$store.state.skinFile": function () {
                this.addLinkTag({
                    rel: "stylesheet",
                    type: "text/css",
                    href: this.$store.state.skinFile
                });
            }
        },
        mounted() {
            window.bsml.convertIcons();
        },
        methods: {
            addLinkTag: function (obj) {

                let link = document.createElement('link');

                if (obj.type)
                    link.type = obj.type;

                if (obj.sizes)
                    link.sizes = obj.sizes;

                if (obj.rel)
                    link.rel = obj.rel;

                if (obj.href)
                    link.href = obj.href;

                if (obj.color)
                    link.color = obj.color;

                if (obj.media)
                    link.media = obj.media;

                head.appendChild(link);
            }
        }
    }
</script>
<style>
    #containerLogo{
        background-position: left center;
    }
    .brand-img-without-hover{
        width: 100%;
        height: 50px;
        background-repeat: no-repeat;
        background-position: 50%;
        background-size: contain;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
</style>